<template>
    <div class="container-fluid">
        <Breadcrumb :button-show="isAdmin" title="Offers" button-url="offersAdd"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="isAdmin">
                                <treeselect placeholder="Search by Archive Status"
                                            :clearable=false
                                            v-model="archiveStatusSearch"
                                            :options="archiveStatusSelect"/>
                            </div>
                            <div class="form-group" v-if="isAdmin">
                                <treeselect placeholder="Search by owner"
                                            v-model="userSearch"
                                            :options="userSelect"
                                            :load-options="loadUsers"
                                            :auto-load-root-options="false"/>
                            </div>
                            <input v-model="offerSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by name">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="offerList.length > 0">
                                <div class="table-responsive">
                                    <table class="table" id="offerTable">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Health</th>
                                            <th>Name</th>
                                            <th>Url</th>
                                            <th>Category</th>
                                            <th v-if="isAdmin">Owner</th>
                                            <th v-if="showArchive">Archive</th>
                                            <th v-if="isAdmin">Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(offer, index) in offerList" :key="index">
                                            <td class="align-middle">{{offer.id}}</td>
                                            <td class="align-middle pl-4">
                                                <span class="btn p-0" @click="showHealth(offer.clean)">
                                                    <h3 class="mb-0">
                                                        <span
                                                              v-bind:class="[(offer.clean === null || offer.clean.length === 0) ? smileClass : sadClass]"
                                                        ></span>
                                                    </h3>
                                                </span>
                                            </td>
                                            <td class="align-middle">{{offer.name}}</td>
                                            <td class="align-middle">{{decodeURI(offer.url)}}</td>
                                            <td class="align-middle">{{offer.category.name}}</td>
                                            <td class="align-middle" v-if="isAdmin">{{offer.user.username}}</td>
                                            <td class="align-middle" v-if="showArchive">{{offer.archive ? moment(offer.archive.toString()).format('Y-M-D') : '-'}}</td>
                                            <td class="align-middle" v-if="isAdmin">
                                                <router-link :to="{ name: 'offersEdit', params: { id: offer.id }}"
                                                             class="btn btn-info btn-sm m-r-10">
                                                    <i class="fa fa-edit"></i> Edit
                                                </router-link>
                                                <button type="button" class="btn btn-danger btn-sm" v-if="!offer.archive"
                                                        @click="archiveOffer(offer.id)">
                                                    <i class="fa fa-minus-circle"></i> Archive
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <paginate v-if="pageCount > 1"
                                      v-model="page"
                                      :page-count="pageCount"
                                      :page-range="3"
                                      :margin-pages="2"
                                      :click-handler="getItems"
                                      :prev-text="'Prev'"
                                      :next-text="'Next'"
                                      :container-class="'pagination justify-content-center'"
                                      :page-class="'page-item'"
                                      :page-link-class="'page-link'"
                                      :prev-class="'page-item'"
                                      :prev-link-class="'page-link'"
                                      :next-class="'page-item'"
                                      :next-link-class="'page-link'">
                            </paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import OfferService from '../services/OfferService'
    import Preloader from '../components/Preloader';
    import UserService from '../services/UserService';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';

    export default {
        name: 'Offers',
        components: {
            Preloader,
            Treeselect,
            Breadcrumb
        },
        mixins: [ paginateMixin ],
        data() {
            return {
                offerSearch: null,
                offerList: [],
                userSearch: null,
                userSelect: null,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                loading: false,
                isAdmin: false,
                archiveStatusSearch: false,
                archiveStatusSelect: [
                    {id: 'all', label: 'All'},
                    {id: true, label: 'Archive'},
                    {id: false, label: 'Current'}
                ],
                showArchive: false,
                smileClass: 'ti-face-smile text-success',
                sadClass: 'ti-face-sad text-danger',
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
            this.getItems(this.page = 1);
        },
        methods: {
            loadUsers({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userSelect = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            getItems: function () {
                this.showArchive = this.isAdmin && (this.archiveStatusSearch !== false);
                this.loading = true;
                OfferService.getOffers(this.page, this.perPage, this.offerSearch, this.userSearch, this.archiveStatusSearch).then(response => {
                    this.offerList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            archiveOffer(id) {
                Swal({
                    title: 'Are you sure you want to move it to the archive?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return OfferService.archiveOffer(id).then((response) => {
                            if (response.status === 200) {
                                this.getItems(this.page);
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Failed: ${error.response.data.error[0]}`
                            );
                            return false;
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Archived successfully!',
                            `Offer has been archived.`,
                            'success'
                        )
                    }
                })
            },
            showHealth: function (data) {
                let type;
                if (data === null || data.length === 0) {
                    data = 'Good.';
                    type = 'success';
                } else {
                    type = 'error';
                }
                Swal({
                    type: type,
                    text: data
                });
            },
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>
